/**
 * One click, then one confirmation. Nothing else.
 *
 * The kill switch (§7.3) is a safety control: no fee, no delay, no reason field,
 * no typed confirmation, no multi-step flow. This component deliberately has no
 * prop that could add any of those, so a later "just add a reason box" change has
 * to be an argued edit rather than a config flag.
 */

import { useState } from 'react';
import type { ReactNode } from 'react';
import { Dialog } from './Dialog';

export function ConfirmButton({
  label,
  confirmTitle,
  confirmBody,
  confirmLabel,
  onConfirm,
  disabled,
  pending,
  variant = 'danger',
}: {
  label: ReactNode;
  confirmTitle: string;
  confirmBody: ReactNode;
  confirmLabel: string;
  onConfirm: () => void | Promise<unknown>;
  disabled?: boolean;
  pending?: boolean;
  variant?: 'danger' | 'primary' | 'ghost';
}) {
  const [asking, setAsking] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`btn btn-${variant}`}
        onClick={() => setAsking(true)}
        disabled={disabled || pending}
      >
        {pending ? 'Working…' : label}
      </button>
      <Dialog
        open={asking}
        onClose={() => setAsking(false)}
        title={confirmTitle}
        labelledBy="confirm-title"
        footer={
          <>
            <button type="button" className="btn btn-ghost" onClick={() => setAsking(false)}>
              Cancel
            </button>
            <button
              type="button"
              className={`btn btn-${variant}`}
              onClick={() => {
                setAsking(false);
                void onConfirm();
              }}
            >
              {confirmLabel}
            </button>
          </>
        }
      >
        {confirmBody}
      </Dialog>
    </>
  );
}
